import resource from './resource'
import ewsCalendar from './ews-calendar'


export default{
    resource,
    ewsCalendar
}